import { render, staticRenderFns } from "./LeaveEncashmentReportPrint.vue?vue&type=template&id=2ff2ddca&scoped=true&"
import script from "./LeaveEncashmentReportPrint.vue?vue&type=script&lang=js&"
export * from "./LeaveEncashmentReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./LeaveEncashmentReportPrint.vue?vue&type=style&index=0&id=2ff2ddca&lang=scss&scoped=true&"
import style1 from "./LeaveEncashmentReportPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2ddca",
  null
  
)

export default component.exports